module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Typewriter-Medium.468df55e.eot";